import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=2a044323&"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlayVideoWrapper: require('/tmp/build_dc55b0b5/src/components/media/PlayVideoWrapper.vue').default,DynamicContainer: require('/tmp/build_dc55b0b5/src/components/DynamicContainer/DynamicContainer.vue').default})
